import React from "react";
import { inject, observer } from "mobx-react";
import GameCard from "./gameCardV2";
import InfiniteScroll from "react-infinite-scroller";
import "./stylesheets/gameList.scss";

@inject("languageStore", "gameStore")
@observer
export default class GameList extends React.Component {
  gameList = React.createRef();

  componentDidMount() {
    this.stickyGame();
  }

  /*
   * 滚动并高亮对应赛事
   */
  stickyGame = () => {
    let { games } = this.props;
    let currentGameId = this.props.gameStore.currentGameId;

    // 找出与url id里相匹配的赛事的下标
    let targetGameIndex = games.findIndex(game => game.id === currentGameId);

    // 如果命中url中有id，而且当前列表没有需要命中的赛事，那么找下一个分页，直到翻完所有页，或者找到该赛事
    if (currentGameId && targetGameIndex === -1 && this.props.gameStore.gameListV2HasMore) {
      return this.props.gameStore.getGameListMore().then(() => {
        this.stickyGame();
      });
    }
    // 拿到gameList元素的所有子元素
    let gameList = this.gameList.current && this.gameList.current.childNodes;
    if (targetGameIndex !== -1) {
      let currentGame = gameList.length > 0 ? gameList[targetGameIndex] : null;
      // 元素显示在屏幕中间时距离视口顶部的值 182为一个赛事卡片的值
      let eleCenterPositionTop = (document.documentElement.clientHeight - 182) / 2;
      // 实际滚动的值 = 元素距离顶部的值-元素距离视口顶部的值；72为顶部header的高度
      let actualScroll = currentGame.offsetTop + 72 - eleCenterPositionTop;
      let time = null;
      setInterval(time);

      time = setInterval(() => {
        // 滚动的速度
        let speed = 400;
        actualScroll =
          actualScroll >= document.documentElement.scrollHeight - window.innerHeight
            ? document.documentElement.scrollHeight - window.innerHeight
            : actualScroll;
        if (document.documentElement.scrollTop >= actualScroll) {
          clearInterval(time);
        } else {
          document.documentElement.scrollTop += speed;
        }
      }, 10);
    }
  };

  loadMoreGame() {
    return this.props.gameStore.getGameListMore();
  }
  // 置顶专属招聘活动
  toppingExclusiveEvent = games => {
    let data = [...games];
    const idx = data.findIndex(
      item =>
        item.attributes && item.attributes.category && item.attributes.category.event_type === 999
    );
    if (idx < 0) return data;
    if (idx > 0) {
      data.unshift(...data.splice(idx, 1));
    }

    return data;
  };

  render() {
    let games = this.toppingExclusiveEvent(this.props.games);
    const lang = this.props.languageStore.lang;

    return (
      <InfiniteScroll
        loadMore={this.loadMoreGame.bind(this)}
        hasMore={this.props.gameStore.gameListV2HasMore}
        initialLoad={false}
        threshold={2000}
        loader={
          <div className="infinite-loader" key={0}>
            {this.props.languageStore.getResource(lang, "LOADING")}
          </div>
        }
      >
        <div className="game-list" ref={this.gameList}>
          {games.map(game => {
            return <GameCard key={game.id} data={game} />;
          })}
        </div>
      </InfiniteScroll>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/game/gameListV2.js